<template>
<div class="drawerWrap drawerWrap1" :style="{paddingBottom:disabled ? '10px' : '60px'}">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="140px">
      <el-form-item label="id" prop="id" v-show="false">
        <el-input v-model="form.id" :disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item label="所属单位" prop="parentId">
        <span>{{this.storage.getSession("orgName")}}</span>
      </el-form-item>
      <el-form-item label="单位名称" prop="name">
        <el-input v-model="form.name" :disabled="disabled" maxlength="20" placeholder="请输入单位名称"></el-input>
      </el-form-item>
      <el-form-item label="所属行业" prop="industry">
        <el-select v-model="form.industry" placeholder="请选择所属行业" :disabled="disabled">
          <el-option v-for="item in unitTypeOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="消防级别" prop="fireLevel">
        <el-select v-model="form.fireLevel" placeholder="请选择消防级别" :disabled="disabled">
          <el-option v-for="item in fireLevelOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="组织机构代码" prop="code">
        <el-input v-model="form.code" :disabled="disabled" maxlength="18" placeholder="请输入组织机构代码"></el-input>
      </el-form-item>
      <div class="unitType">
        <el-form-item label="单位地址" prop="address">
          <el-input ref="addrInput" v-model="form.address" :disabled="disabled" maxlength="50" placeholder="请输入单位地址"></el-input><i class="imgPosition" v-show="!disabled" @click="mapShow">&nbsp;&nbsp;&nbsp;<img src="../../assets/img/position.png" alt=""></i>
        </el-form-item>
      </div>
      <el-form-item label="法定代表人" prop="legalPerson">
        <el-input v-model="form.legalPerson" maxlength="20" :disabled="disabled" placeholder="请输入法定代表人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="legalPersonPhone">
        <el-input v-model="form.legalPersonPhone" :disabled="disabled" maxlength="11" placeholder="请输入法人联系电话"></el-input>
      </el-form-item>
      <el-form-item label="消防安全管理人" prop="fireSafetyManager">
        <el-input v-model="form.fireSafetyManager" maxlength="20" :disabled="disabled" placeholder="请输入消防安全管理人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="managerPhone">
        <el-input v-model="form.managerPhone" :disabled="disabled" oninput = "value=value.replace(/[^\d]/g,'')"   maxlength="11" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="消防安全责任人" prop="fireSafetyPersonLiable">
        <el-input v-model="form.fireSafetyPersonLiable" :disabled="disabled" maxlength="20" placeholder="请输入消防安全责任人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="liablePhone">
        <el-input v-model="form.liablePhone" :disabled="disabled" oninput = "value=value.replace(/[^\d]/g,'')"  maxlength="11" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="专职消防人" prop="fullTimeFireFightersCount">
        <el-input v-model="form.fullTimeFireFightersCount" :disabled="disabled" oninput = "value=value.replace(/[^\d]/g,'')" maxlength="10" placeholder="请输入专职消防人"></el-input><span class="sp">&nbsp;&nbsp;&nbsp;人</span>
      </el-form-item>
      <el-form-item label="义务消防人" prop="obligationFireFightersCount">
        <el-input v-model="form.obligationFireFightersCount" maxlength="10" oninput = "value=value.replace(/[^\d]/g,'')" :disabled="disabled" placeholder="请输入义务消防人"></el-input><span class="sp">&nbsp;&nbsp;&nbsp;人</span>
      </el-form-item>
      <el-form-item label="建筑面积" prop="floorage">
        <el-input v-model="form.floorage" maxlength="10" :disabled="disabled" placeholder="请输入建筑面积"></el-input><span class="sp">&nbsp;&nbsp;&nbsp;平方米</span>
      </el-form-item>
      <el-form-item label="安全出口数" prop="exitCount">
        <el-input v-model="form.exitCount" maxlength="10" :disabled="disabled" placeholder="请输入安全出口数"></el-input>
      </el-form-item>
      <el-form-item label="消防车道数" prop="firePassagesCount">
        <el-input v-model="form.firePassagesCount" maxlength="10" :disabled="disabled" placeholder="请输入消防车道数"></el-input>
      </el-form-item>
      <el-form-item label="疏散楼梯数" prop="evacuationPassageCount">
        <el-input v-model="form.evacuationPassageCount" :disabled="disabled" maxlength="10" placeholder="请输入疏散楼梯数"></el-input>
      </el-form-item>
      <el-form-item label="消防电梯数" prop="fireLiftCount">
        <el-input v-model="form.fireLiftCount" maxlength="10" :disabled="disabled" placeholder="请输入消防电梯数"></el-input>
      </el-form-item>
      <el-form-item label="避难层数" prop="refugeFloorCount">
        <el-input v-model="form.refugeFloorCount" maxlength="10" oninput = "value=value.replace(/[^\d]/g,'')" :disabled="disabled" placeholder="请输入避难层数"></el-input>
      </el-form-item>
      <el-form-item label="避难层位置" prop="refugeFloorAddress">
        <el-input v-model="form.refugeFloorAddress" maxlength="20" :disabled="disabled" placeholder="请输入避难层位置"></el-input>
      </el-form-item>
      <el-form-item label="避难层总面积" prop="refugeFloorage">
        <el-input v-model="form.refugeFloorage" maxlength="10" oninput = "value=value.replace(/[^\d]/g,'')" :disabled="disabled" placeholder="请输入避难层总面积"></el-input><span class="sp">&nbsp;&nbsp;&nbsp;平方米</span>
      </el-form-item>
      <div class="unitImg">
        <el-form-item label="公司图片">
          <el-upload :class="{'demo-httpRequestImg':httpRequestImg}" :before-upload="beforeAvatarUpload" action :disabled="disabled" :limit="1" list-type="picture-card" :http-request="handleHttpRequest" :on-preview="handlePictureCardPreview" :file-list="fileList" :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :append-to-body='true' :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </div>
    </el-form>
  </div>
  <div class="drawerFoot" v-if="!disabled">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button v-show="!disabled" @click="cancelHandle()">取 消</el-button>
  </div>
  
</div>
</template>

<script>
// var md5 = require("js-md5");
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  connect
} from 'tls';
export default {
  components: {
    //  ElFormItem,
    Treeselect
  },
  watch: {
    selectAddr(newV){
      console.log(newV);
      this.form.address = newV.address
      this.form.latitude = newV.point.lat
      this.form.longitude = newV.point.lng
      this.$refs.addrInput.focus()
      this.$refs.addrInput.blur()
    }
  },
  props: {
    detailData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectAddr:{
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      httpRequestImg:false,//展示单个图片
      checked: true,
      radio: "1",
      // loading: false,
      orgList: [],
      roleList: [],
      fireLevelOptions: [],
      unitTypeOptions: [],
      form: {
        id: 0,
        parentId: this.storage.getSession("orgId"),
        name: '',
        serial: 50,
        address: '',
        area: '',
        code: '',
        evacuationPassageCount: '',
        exitCount: '',
        fireLevel: '',
        fireLiftCount: '',
        firePassagesCount: '',
        fireSafetyManager: '',
        fireSafetyPersonLiable: '',
        floorage: '',
        fullTimeFireFightersCount: '',
        industry: '',
        latitude: '',
        longitude: '',
        legalPerson: '',
        legalPersonPhone: '',
        liablePhone: '',
        managerPhone: '',
        obligationFireFightersCount: '',
        refugeFloorAddress: '',
        refugeFloorCount: '',
        refugeFloorage: ''
      },
      formRules: {
        name: [{
          required: true,
          validator: this.validateName,
          trigger: "blur"
        }],
        industry: [{
          required: true,
          message: "所属行业不能为空",
          trigger: "change"
        }],
        fireLevel: [{
          required: true,
          message: "防火等级不能为空",
          trigger: "change"
        }],
        code: [{
          required: true,
          validator: this.validateCode,
          trigger: "blur"
        }],
        address: [{
          required: true,
          message: "单位地址不能为空",
          trigger: "blur"
        }],
        legalPerson: [{
          required: true,
          validator: this.validateLegalPerson,
          trigger: "blur"
        }],
        legalPersonPhone: [{
          required: true,
          validator: this.validateConnect,
          trigger: "blur"
        }],
      //   fireSafetyManager: [{
      //     required: true,
      //     validator: this.validateFireSafetyManager,
      //     trigger: "blur"
      //   }],
      //   managerPhone: [{
      //    //  required: true,
      //    //  validator: this.validateConnect,
      //    //  trigger: "blur"
      //     required: true,
      //     message: "联系电话不能为空",
      //     trigger: "blur"
      //   }],
      //   fireSafetyPersonLiable: [{
      //     required: true,
      //     validator: this.validateFireSafetyPersonLiable,
      //     trigger: "blur"
      //   }],
      //   liablePhone: [{
      // //     required: true,
      // //     validator: this.validateConnect,
      // //     trigger: "blur"
      //     required: true,
      //     message: "联系电话不能为空",
      //     trigger: "blur"
      //   }],
      //   fullTimeFireFightersCount:[{
      //     required: true,
      //     validator: this.validateFullTimeFireFightersCount,
      //     trigger: "blur"
      //   }],
      //   obligationFireFightersCount:[{
      //     required: true,
      //     validator: this.validateObligationFireFightersCount,
      //     trigger: "blur"
      //   }],
        floorage:[{
          required: true,
          validator: this.validateFloorage,
          trigger: "blur"
        }],
        exitCount:[{
          required: true,
          validator: this.validateExitCount,
          trigger: "blur"
        }],
        firePassagesCount:[{
          required: true,
          validator: this.validateFirePassagesCount,
          trigger: "blur"
        }],
        evacuationPassageCount:[{
          required: true,
          validator: this.validateEvacuationPassageCount,
          trigger: "blur"
        }],
        fireLiftCount:[{
          required: true,
          validator: this.validateFireLiftCount,
          trigger: "blur"
        }],
      //   refugeFloorCount:[{
      //     required: true,
      //     validator: this.validateRefugeFloorCount,
      //     trigger: "blur"
      //   }],
      //   refugeFloorage:[{
      //     required: true,
      //     validator: this.validateRefugeFloorage,
      //     trigger: "blur"
      //   }]
      },
      fileList: [],
      isReuploadImg: false,
      resetPwd: false,
      imgPath: "",
      dialogImageUrl: '',
      imgData: null,
      dialogVisible: false,
      disabled: false,
      orgOptions: []
    };
  },
  created() {
    this.showOrgOptions();
    this.showOptions("org_type");
    this.showOptions("org_rating_type");    
  },
  mounted() {
    this.init();
  },
  methods: {
    showOrgOptions() {
      this.request
        .get("/organization/findTreeById?id=0")
        .then(data => {
          // console.log(data);
          if (200 === data.code) {
            let orgArr = data.data;
            this.orgOptions = orgArr && orgArr.length ? orgArr : [];
          } else {
            this.msg.error(data.msg);
          }
        })
        .catch(e => this.msg.error(e));
    },
    showOptions(type) {
      this.request
        .get("/Dictionary/query?type=" + type)
        .then(data => {
          // console.log(data);
          if (200 === data.code) {
            if (type == 'org_rating_type') {
              this.fireLevelOptions = data.data;
            } else if (type == 'org_type') {
              this.unitTypeOptions = data.data;
            }
          } else {
            this.msg.error(data.msg);
          }
        })
        .catch(e => this.msg.error(e));
    },
    init() {
      if (this.editData.id) {
        this.form = {
          ...this.editData
        }
        if (this.editData.image) {
         this.httpRequestImg=true           
          let obj = new Object();
          obj.url = this.editData.image;
          this.fileList.push(obj);
         //  this.imgData = this.fileList[0]
          console.log(this.form);
        }else{
           this.httpRequestImg=false
        }
      }
      if (this.detailData.id) {
        this.form = {
          ...this.detailData
        }
        this.disabled = true;
        console.log(this.detailData);
        if (this.detailData.image) {
           this.httpRequestImg=true
          let obj = new Object();
          obj.url = this.detailData.image;
          this.fileList.push(obj);
        }else{
           this.httpRequestImg=false
        }
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleHttpRequest(obj) {
      this.imgData = obj.file;
      console.log(obj.file);
      this.httpRequestImg = true;
    },
    //对上传图片的大小、格式进行限制
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isJPG2 = file.type === "image/jpg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning("只支持jpeg或jpg或png格式图片");
      }
      if (!isLt5M) {
        this.$message.warning("请上传1MB以内的图片!");
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M;
    },
    handleRemove(file, fileList) {
      this.httpRequestImg = false;
      this.dialogImageUrl = "";
      this.fileList = [];
    },
    cancelHandle() { //取消
      this.$emit("cancel", false);
    },
    confirmHandle() { //确认
      console.log(this.fileList);

      // 通过 FormData 对象上传文件
      var _this = this;
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        } else {
          this.$emit("update:loading", true);
          const formData = new FormData();
          let obj = {
            ...this.form
          };
          console.log(obj);
          if(obj.fullTimeFireFightersCount==null){
             obj.fullTimeFireFightersCount = ''
          }
          if(obj.obligationFireFightersCount==null){
             obj.obligationFireFightersCount = ''
          }
          if(obj.refugeFloorCount==null){
             obj.refugeFloorCount= ''
          }
          Object.keys(obj).forEach(key => {
            formData.append(key, obj[key]);
          });
          // console.log(this.imgData === null);
          console.log(this.imgData);
          console.log(obj);
         //  return
          if(this.imgData){
            formData.append("file", this.imgData)
          } 
          if (this.form.id == 0 || this.form.id == null || this.form.id == '') {
            this.request.postParamsForm("/organization/add", {}, formData).then(data => {
              if (data.code == 200) {
                _this.$message.success("添加成功");
                // Object.assign(_this.form, _this.$options.data().form)
                _this.fileList = [];
                //预留 关闭子页面 刷新父页面数据
                _this.$emit('confirm', false)
              } else {
                _this.$message.error("新增失败:" + data.msg);
              }
              this.$emit("update:loading", false)

            })
          } else {
             console.log(formData);
             
            this.request.postParamsForm("/organization/edit", {}, formData).then(data => {
              if (data.code == 200) {
                _this.$message.success("修改成功");
                // Object.assign(_this.form, _this.$options.data().form)
                _this.fileList = [];
                _this.$emit('confirm', false)
                //预留 关闭子页面 刷新父页面数据
              } else {
                _this.$message.error("编辑失败:" + data.msg);
              }
              this.$emit("update:loading", false)
            })
          }

        }
      });
    },
    mapShow() { //地图定位
      this.$emit('getPosition')
    },
    validateName(rule, value, callback) {
       console.log(value);
       
      if (value.replace(/^\s*|\s*$/g, '') === "") {
        callback(new Error("单位名称不能为空"));
      } else {
      //   var reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
      //   var reg=new RegExp(/^[^\s].*[^\s]$/)
      //   if (!reg.test(value)) {
      //     callback(
      //       new Error("格式不合法,单位名称不能为空格，且首尾不能有空格！")
      //     );
      //   } else {
          callback();
      //   }
      }
    },
    validateCode(rule, value, callback) {
      if (value === "") {
        callback(new Error("组织机构代码不能为空"));
      } else if (value.length != 18) {
        callback(new Error("组织机构代码长度必须为18个字符"));
      } else {
        var reg = new RegExp(/^[0-9A-Z]*$/);
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入由英文(A-Z)或数字组成的编码！"));
        } else {
          callback();
        }
      }
    },
    validateLegalPerson(rule, value, callback) {
      if (value.replace(/^\s*|\s*$/g, '') === "") {
        callback(new Error("企业法人不能为空"));
      }else {
          callback();
      }
    },
    validateConnect(rule, value, callback) {
      if (value === "") {
        callback(new Error("联系电话不能为空"));
      } else {
        var reg=new RegExp(/^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/)
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入正确的11位数字组成的联系电话！"));
        } else {
          callback();
        }
      }
    },
    validateFireSafetyManager(rule, value, callback) {
      if (value === "") {
        callback(new Error("安全管理人不能为空"));
      } else {
        var reg = new RegExp(/^[A-Za-z\u4e00-\u9fa5]+$/);
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入由英文(a-z/A-Z)或中文汉字组成的安全管理人！"));
        } else {
          callback();
        }
      }
    },
    validateFireSafetyPersonLiable(rule, value, callback) {
      if (value === "") {
        callback(new Error("安全责任人不能为空"));
      } else {
        var reg = new RegExp(/^[A-Za-z\u4e00-\u9fa5]+$/);
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入由英文(a-z/A-Z)或中文汉字组成的安全责任人！"));
        } else {
          callback();
        }
      }
    },
    validateFullTimeFireFightersCount(rule, value, callback){
       if (value === "") {
        callback(new Error("专职消防人数不能为空"));
      } else {
        var reg = new RegExp(/^(0|[1-9][0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入由正整数组成的数字！"));
        } else {
          callback();
        }
      }
    },
    validateObligationFireFightersCount(rule, value, callback){
       if (value === "") {
        callback(new Error("义务消防人数不能为空"));
      } else {
        var reg = new RegExp(/^(0|[1-9][0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入由正整数组成的数字！"));
        } else {
          callback();
        }
      }
    },
    validateFloorage(rule, value, callback){
       if (value === "") {
        callback(new Error("建筑面积不能为空"));
      } else {
        var reg = new RegExp(/^[1-9]d*.d*|0.d*[1-9]d*$/);
        var reg1=new RegExp(/^(0|[1-9][0-9]*)$/)
        if (!reg.test(value)&&!reg1.test(value)) {
          callback(new Error("格式不合法,请输入由正整数及正浮点数组成的数字！"));
        } else {
          callback();
        }
      }
    },
    validateExitCount(rule, value, callback){
       if (value === "") {
        callback(new Error("安全出口数不能为空"));
      } else {
        var reg = new RegExp(/^(0|[1-9][0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入由正整数组成的数字！"));
        } else {
          callback();
        }
      }
    },
    validateFirePassagesCount(rule, value, callback){
       if (value === "") {
        callback(new Error("消防车道数不能为空"));
      } else {
        var reg = new RegExp(/^(0|[1-9][0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入由正整数组成的数字！"));
        } else {
          callback();
        }
      }
    },
    validateEvacuationPassageCount(rule, value, callback){
       if (value === "") {
        callback(new Error("疏散楼梯数不能为空"));
      } else {
        var reg = new RegExp(/^(0|[1-9][0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入由正整数组成的数字！"));
        } else {
          callback();
        }
      }
    },
    validateFireLiftCount(rule, value, callback){
       if (value === "") {
        callback(new Error("消防电梯数不能为空"));
      } else {
        var reg = new RegExp(/^(0|[1-9][0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入由正整数组成的数字！"));
        } else {
          callback();
        }
      }
    },
    validateRefugeFloorCount(rule, value, callback){
       if (value === "") {
        callback(new Error("避难层数不能为空"));
      } else {
        var reg = new RegExp(/^(0|[1-9][0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入由正整数组成的数字！"));
        } else {
          callback();
        }
      }
    },
    validateRefugeFloorage(rule, value, callback){
       if (value === "") {
        callback(new Error("避难层总面积不能为空"));
      } else {
        var reg = new RegExp(/^[1-9]d*.d*|0.d*[1-9]d*$/);
        var reg1=new RegExp(/^(0|[1-9][0-9]*)$/)
        if (!reg.test(value)&&!reg1.test(value)) {
          callback(new Error("格式不合法,请输入由正整数及正浮点数组成的数字！"));
        } else {
          callback();
        }
      }
    }
  }
};
</script>

<style lang="scss">

.drawerWrap1 {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;
    overflow: hidden;

    .el-form-item {
      width: 50%;
      float: left;
    }

    .unitType {
      .el-form-item {
        width: 100%;

        .el-input {
          width: 73.3%;

          .el-input__inner {
            height: 40px;
            line-height: 40px;
          }
        }
      }

      .imgPosition {
        display: inline-block;
        width: 28px;
        height: 28px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .unitImg {
      .el-form-item {
        width: 100%;
      }
    }

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;
    }

    .el-select {
      width: 270px;

      .el-input {
        width: 270px;
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }

  .el-button--primary {
    color: #FFF;
    background-color: #2074E6;
    border-color: #2074E6;
  }

  .el-button--primary:focus,
  .el-button--primary:hover {
    background: #4074E6;
    border-color: #4074E6;
    color: #FFF;
  }
   .demo-httpRequestImg{
   //  ::v-deep  
      .el-upload--picture-card{
         display: none;
      }
  } 

}
</style>
